import { createSelector } from 'reselect'
import { isEqual } from 'lodash'
import { RootStoreState } from '@src/models/app.types'

const unifiedOnboardingStoreSelector = (state: RootStoreState) => state.unifiedOnboarding

export const upsellOffersSelector = createSelector(
  unifiedOnboardingStoreSelector,
  (store) => store.upsellOffers,
  {
    memoizeOptions: {
      resultEqualityCheck: isEqual,
    },
  },
)
